module.exports = __webpack_public_path__ + "static/media/serv-1.cd115315.jpg";